var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCallOutgoing = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .call-outgoing-class-a {\n                fill: #fff;\n            }\n\n            .call-outgoing-class-b {\n                fill: none !important;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1194.997 -1069.735)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(32)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "call-outgoing-class-a",
    d: "M5.817,9.061a11.787,11.787,0,0,0,5.128,5.128l1.712-1.712a.774.774,0,0,1,.794-.187,8.876,8.876,0,0,0,2.778.444.78.78,0,0,1,.778.778v2.716a.78.78,0,0,1-.778.778A13.227,13.227,0,0,1,3,3.778.78.78,0,0,1,3.778,3H6.5a.78.78,0,0,1,.778.778,8.84,8.84,0,0,0,.444,2.778.781.781,0,0,1-.195.794Z",
    transform: "translate(1163.997 1072.497)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "call-outgoing-class-a",
    d: "M8.421,1.018,7.367,0,1.434,5.83V2.054H0v6.21H6.2V6.832H2.574Z",
    transform: "translate(1214.921 1082) rotate(180)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "call-outgoing-class-b",
    d: "M0,0H24V24H0Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCallOutgoing);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_call_outgoing.198f8a77ec9c17014743fa0e19e4e448.svg";